import { styled } from "@mui/material/styles";
import { Box, Fade, IconButton } from "@mui/material";

export const AnimatedContainer = styled(Fade)(({ theme }) => ({
  backgroundColor: "black",
  opacity: 0.95,
  borderRadius: "10px",
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
}));

export const RootContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "50px",
  paddingRight: "50px",
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  margin: "30px",
}));
